import { useMutation } from "@tanstack/react-query";

import { useOnboardingApi } from "../hooks/useOnboardingApi";

const useRequestPasswordReset = () => {
  const { api } = useOnboardingApi();

  return useMutation({
    mutationFn: (email: string) => api.onboarding.requestPasswordReset(email),
  });
};

export default useRequestPasswordReset;
